import { render } from "./GroupButtons.vue?vue&type=template&id=40eef32a"
import script from "./GroupButtons.vue?vue&type=script&lang=js"
export * from "./GroupButtons.vue?vue&type=script&lang=js"

import "./GroupButtons.vue?vue&type=style&index=0&id=40eef32a&lang=scss"

import exportComponent from "/home/wf13/Develop/web/vue-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__